import { render, staticRenderFns } from "./prozhushou.vue?vue&type=template&id=27868b90&scoped=true&"
import script from "./prozhushou.vue?vue&type=script&lang=js&"
export * from "./prozhushou.vue?vue&type=script&lang=js&"
import style0 from "./prozhushou.vue?vue&type=style&index=0&id=27868b90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27868b90",
  null
  
)

export default component.exports